import axios from './api'


export const getSalesPersonData = async () => {
  const response = await axios.get('/admin/salesperson')
  return response.data
}

export const saveSalesPersonData = async (data) => {
  const response = await axios.post('/admin/salesperson', data)
  return response.data
}


export const getSalesPersonSettings = async () => {
  const response = await axios.get('/admin/salesperson/settings')
  return response
}

export const updateSalesPersonSettings = async (data) => {
  const response = await axios.put('/admin/salesperson/settings', data)
  return response
}


export const getAllBillings = async (params = {}) => {
  const response = await axios.get('/admin/billings', { params })
  return response.data
}

export const getBillingStats = async () => {
  const response = await axios.get('/admin/billings/stats')
  return response.data
}

export const downloadBillingPDF = async (billingId) => {
  const response = await axios.get(`/admin/billings/${billingId}/pdf`, {
    responseType: 'blob'
  })
  return response
}

export const downloadTeamBillingPDF = async (billingId) => {
  const response = await axios.get(`/admin/team-billings/${billingId}/pdf`, {
    responseType: 'blob'
  })
  return response
}

export const downloadBillingCreditPDF = async (billingId) => {
  const response = await axios.get(`/admin/billings/${billingId}/credit-pdf`, {
    responseType: 'blob'
  })
  return response
}

export const downloadTeamBillingCreditPDF = async (billingId) => {
  const response = await axios.get(`/admin/team-billings/${billingId}/credit-pdf`, {
    responseType: 'blob'
  })
  return response
}

export const exportBillingsExcel = async (params = {}) => {
  const response = await axios.get('/admin/billings/export/excel', {
    params,
    responseType: 'blob'
  })
  return response.data
}

export const exportBillingsZip = async (params = {}) => {
  const response = await axios.get('/admin/billings/export/zip', {
    params,
    responseType: 'blob'
  })
  return response.data
}

// Sales-Report: entfernt

// getAppleReceiptInfo entfernt – Receipt-Flow nicht mehr unterstützt

export const getAppleTransactionHistoryById = async (transactionId) => {
  const response = await axios.post('/admin/apple/transaction-history', { transactionId })
  return response.data
}

export const getAppleInAppBillings = async (params = {}) => {
  const response = await axios.get('/admin/apple/inapp-billings', { params })
  return response.data
}

export const checkAppleInAppBilling = async (billingId) => {
  const response = await axios.post(`/admin/apple/inapp-billings/${billingId}/check`)
  return response.data
}

export const markBillingAsPaid = async (billingId, billingType = 'billing') => {
  const response = await axios.post('/admin/billings/mark-as-paid', {
    billingId,
    billingType
  })
  return response.data
}

export const recheckPayPalPayment = async (billingId, billingType = 'billing') => {
  const response = await axios.post('/admin/billings/recheck-paypal', {
    billingId,
    billingType
  })
  return response.data
}

export const cancelBillingRequest = async (billingId, billingType = 'billing') => {
  const response = await axios.post('/admin/billings/cancel', {
    billingId,
    billingType
  })
  return response.data
}

export const deleteBilling = async (billingId, billingType = 'billing') => {
  const response = await axios.post('/admin/billings/delete', {
    billingId,
    billingType
  })
  return response.data
}

export const recreateBillingInvoice = async (billingId, billingType = 'billing') => {
  const response = await axios.post('/admin/billings/recreate', {
    billingId,
    billingType
  })
  return response.data
}

export const cancelInvoiceWithCredit = async (billingId, billingType = 'billing') => {
  const response = await axios.post('/admin/billings/cancel-with-credit', {
    billingId,
    billingType
  })
  return response.data
}


export const downloadFile = (blob, filename) => {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}


export const getAllUsers = async (params = {}) => {
  const response = await axios.get('/admin/users', { params })
  return response.data
}

export const deleteUser = async (userId, confirmation) => {
  const response = await axios.delete(`/admin/users/${userId}`, {
    data: { confirmation }
  })
  return response.data
}

export const getUserTeams = async (userId, params = {}) => {
  const response = await axios.get(`/admin/users/${userId}/teams`, { params })
  return response.data
}

export const impersonateUser = async (userId) => {
  const response = await axios.post(`/admin/users/${userId}/impersonate`)
  return response.data
}

export const getUserHistory = async (userId, params = {}) => {
  const response = await axios.get(`/admin/users/${userId}/history`, { params })
  return response.data
}

export const syncFluentcrmUsers = async () => {
  const response = await axios.post('/admin/users/fluentcrm/sync')
  return response.data
}

export const getAllTeams = async (params = {}) => {
  const response = await axios.get('/admin/teams', { params })
  return response.data
}

export const getGoogleStoreEarnings = async () => {
  const response = await axios.get('/admin/stores/google/earnings')
  return response.data
}

export const getAppleStoreEarnings = async () => {
  const response = await axios.get('/admin/stores/apple/earnings')
  return response.data
}

export const downloadGoogleStoreCsv = async (year, month, fileName = null) => {
  const params = {}
  if (fileName) params.file = fileName
  const response = await axios.get(`/admin/stores/google/earnings/${year}/${month}/csv`, {
    params,
    responseType: 'blob'
  })
  return response
}

export const downloadGoogleStorePdf = async (year, month) => {
  const response = await axios.get(`/admin/stores/google/earnings/${year}/${month}/pdf`, {
    responseType: 'blob'
  })
  return response
}

export const downloadGoogleStoreZip = async (year, quarter) => {
  const response = await axios.get(`/admin/stores/google/earnings/${year}/quarter/${quarter}/zip`, {
    responseType: 'blob'
  })
  return response
}

export const syncGoogleStoreNow = async () => {
  const response = await axios.post('/admin/stores/google/sync')
  return response.data
}

export const downloadAppleStoreCsv = async (year, month, fileName = null) => {
  const params = {}
  if (fileName) params.file = fileName
  const response = await axios.get(`/admin/stores/apple/earnings/${year}/${month}/csv`, {
    params,
    responseType: 'blob'
  })
  return response
}

export const downloadAppleStorePdf = async (year, month) => {
  const response = await axios.get(`/admin/stores/apple/earnings/${year}/${month}/pdf`, {
    responseType: 'blob'
  })
  return response
}

export const downloadAppleStoreZip = async (year, quarter) => {
  const response = await axios.get(`/admin/stores/apple/earnings/${year}/quarter/${quarter}/zip`, {
    responseType: 'blob'
  })
  return response
}

export const syncAppleStoreNow = async () => {
  const response = await axios.post('/admin/stores/apple/sync')
  return response.data
}

export const adminApi = {
  getSalesPersonData,
  saveSalesPersonData,
  getSalesPersonSettings,
  updateSalesPersonSettings,
  getAllBillings,
  getBillingStats,
  downloadBillingPDF,
  downloadTeamBillingPDF,
  downloadBillingCreditPDF,
  downloadTeamBillingCreditPDF,
  exportBillingsExcel,
  exportBillingsZip,
  getAppleTransactionHistoryById,
  getAppleInAppBillings,
  checkAppleInAppBilling,
  markBillingAsPaid,
  recheckPayPalPayment,
  cancelBillingRequest,
  deleteBilling,
  recreateBillingInvoice,
  cancelInvoiceWithCredit,
  downloadFile,
  getAllUsers,
  deleteUser,
  getUserTeams,
  impersonateUser,
  getUserHistory,
  syncFluentcrmUsers,
  getAllTeams,
  getGoogleStoreEarnings,
  downloadGoogleStoreCsv,
  downloadGoogleStorePdf,
  downloadGoogleStoreZip,
  syncGoogleStoreNow,
  getAppleStoreEarnings,
  downloadAppleStoreCsv,
  downloadAppleStorePdf,
  downloadAppleStoreZip,
  syncAppleStoreNow
} 
